import {request} from '../services/request';
import {backendEndpoints} from '../../api';
import {apiHelpers} from '../../utils/helpers';

const errorHandlerProps = {disableAlert: true};
const hideKeylessErrorHandlerProps = {hideKeylessError: true};

const getEmployees = ({query = null, successCallback, errorCallback}) => {
  return (dispatch, getState) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_COMPANY_TEAM_EMPLOYEES_V2, getState),
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getEmployee = ({email, successCallback, errorCallback}) => {
  return (dispatch, getState) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_COMPANY_TEAM_EMPLOYEE, getState, {email}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const getEmployeeSubscriptions = ({email, query, successCallback, errorCallback}) => {
  return (dispatch, getState) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_COMPANY_TEAM_EMPLOYEE_SUBSCRIPTIONS, getState, {email}),
      query,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const createEmployee = ({data, successCallback, errorCallback}) => {
  return (dispatch, getState) => {
    request.post({
      dispatch,
      url: getUrl(backendEndpoints.POST_COMPANY_TEAM_EMPLOYEE_CREATE, getState),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const deleteEmployee = ({email, successCallback, errorCallback}) => {
  return (dispatch, getState) => {
    request.delete({
      dispatch,
      url: getUrl(backendEndpoints.DELETE_COMPANY_TEAM_EMPLOYEE, getState, {email}),
      successCallback,
      errorCallback,
    });
  }
}

const updateEmployee = ({email, data, successCallback, errorCallback}) => {
  return (dispatch, getState) => {
    request.put({
      dispatch,
      url: getUrl(backendEndpoints.PUT_COMPANY_TEAM_EMPLOYEE_UPDATE, getState, {email}),
      data,
      successCallback,
      errorCallback,
    });
  }
}

const updateEmployeeStatus = ({
  headers,
  email,
  data,
  successCallback,
  errorCallback
}) => {
  return (dispatch, getState) => {
    request.put({
      dispatch,
      headers,
      url: getUrl(backendEndpoints.PUT_COMPANY_TEAM_EMPLOYEE_UPDATE_STATUS, getState, {email}),
      data,
      successCallback,
      errorCallback,
      errorHandlerProps: hideKeylessErrorHandlerProps
    });
  }
}

const resendInvite = ({email, data, successCallback, errorCallback}) => {
  return (dispatch, getState) => {
    request.post({
      dispatch,
      url: getUrl(backendEndpoints.POST_COMPANY_TEAM_EMPLOYEE_RESEND_INVITE, getState, {email}),
      data,
      successCallback,
      errorCallback
    });
  }
}

const getUrl = (url, getState, params = {}) => {
  const {id} = getState().company;
  return apiHelpers.getUrl(url, {id, ...params});
}

export const teamActions = {
  getEmployees,
  getEmployee,
  getEmployeeSubscriptions,
  createEmployee,
  deleteEmployee,
  updateEmployee,
  updateEmployeeStatus,
  resendInvite
};
